/*
 * Project: bellcloud
 * File: apps/frontend/src/pages/configuration/ConfigurationStyles.tsx
 * Description: Styled components for Configuration page layouts
 */

import styled from '@emotion/styled';
import { media } from '@/theme/tokens/breakpoints';

// Top Section - Device Info and Action Buttons
export const TopSection = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  width: 100%;

  ${media.maxXl`
    flex-direction: column;
    gap: 20px;

    > * {
      width: 100% !important;
      max-width: 100% !important;
    }
  `}

  ${media.maxSm`
    width: 100%;
    flex-direction: column;

    > * {
      width: 100% !important;
      max-width: 100% !important;
    }
  `}
`;

// MINI Configuration Grid - General 위, Sensor 아래
export const MiniConfigGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

// Action Buttons
export const ActionButtons = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  ${media.maxXl`
    flex-direction: column;
  `}
`;

export const ButtonLeft = styled.div`
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  flex-wrap: wrap;

  ${media.maxSm`
    flex-direction: column;
    width: 100%;

    > * {
      width: 100% !important;
      max-width: 100% !important;
    }
  `}
`;

// Sensor Grid Base Styles - Create separate components for each variant
const createSensorGrid = (columns: number) => styled.div`
  display: grid;
  gap: 8px;
  width: 100%;
  grid-template-columns: repeat(${columns}, 1fr);
  min-width: 0;

  > *:first-of-type {
    grid-column: 1 / -1;
  }

  ${media.maxXl(`grid-template-columns: ${columns === 1 ? '1fr' : 'repeat(2, 1fr)'};`)}

  ${media.maxSm`grid-template-columns: 1fr;`}
`;

// Sensor Grid Variants
export const SensorGrid1 = createSensorGrid(1);
export const SensorGrid2 = createSensorGrid(2);
export const SensorGrid3 = createSensorGrid(3);
export const SensorGrid4 = createSensorGrid(4);
export const SensorGrid5 = createSensorGrid(5);
